/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-12-28 15:06:28
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-28 15:27:39
 * @FilePath: \ioc_base\src\modules\firePatrol\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [
  // 消防管理-防火巡查项
  {
    path: "/firePatrol/items",
    name: "firePatrolItems",
    component: () => import("@src/modules/firePatrol/view/items"),
    meta: {
      requireAuth: false,
      // module: "firePatrol",
      routerAlive: true
    }
  },
  // 消防管理-防火巡查统计
  {
    path: "/firePatrol/count",
    name: "firePatrolCount",
    component: () => import("@src/modules/firePatrol/view/count"),
    meta: {
      requireAuth: false,
      // module: "firePatrol",
      routerAlive: true
    }
  }
];

export default routes;
